import { render, staticRenderFns } from "./dietduration.vue?vue&type=template&id=2b85d2e8"
import script from "./dietduration.vue?vue&type=script&lang=js"
export * from "./dietduration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports